import React, { useState, useEffect } from 'react';
import { SelectFeautureItem } from './SelectFeautureItem';

export const SelectFeauture = props => {
  const [listFeature, setListFeature] = useState([]);

  useEffect(() => {
    console.warn(props.setFeature);

    if (props.setAvailable !== undefined) {
      console.warn('ADD', props.setFeature[0]['feature']);
      props.setFeature[0]['feature'].forEach(e => {
        listFeature.push(e);
      });
      props.addFeature(listFeature);
    }
    // .filter(element=> element.element===props.element);
  }, []);

  const handleSelectClick = e => {};
  const handleSelectItemClick = e => {
    console.warn(handleSelectItemClick, e);

    if (e.selected) {
      listFeature.push(e);
      props.addFeature(listFeature);
    } else {
      props.addFeature(listFeature.filter(element => element.element !== e.element));
      setListFeature(listFeature.filter(element => element.element !== e.element));
    }
  };

  return (
    <div
      style={{
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '200px',
        width: '100%',
        paddingLeft: '10%',
      }}
    >
      {Object.keys(props.selectListData).map(element => (
        <SelectFeautureItem
          key={element}
          element={element}
          data={props.selectListData[element]}
          onClick={handleSelectItemClick}
          setAvailable={props.setFeature}
        ></SelectFeautureItem>
      ))}
    </div>

    // <Button {...this.props}   />
  );
};
